var theme = {
  colors: [
    "#2b908f",
    "#90ee7e",
    "#f45b5b",
    "#7798BF",
    "#aaeeee",
    "#ff0066",
    "#eeaaee",
    "#55BF3B",
    "#DF5353",
    "#7798BF",
    "#aaeeee"
  ],
  chart: {
    backgroundColor: {
      linearGradient: { x1: 0, y1: 0, x2: 1, y2: 1 },
      stops: [
        [0, "rgba(11, 35, 62, 0.37)"],
        [1, "rgba(11, 35, 62, 0.37)"]
      ]
    },
    style: {
      fontFamily: "'Unica One', sans-serif"
    },
    plotBorderColor: "#606063"
  },
  title: {
    style: {
      color: "#E0E0E3",
      textTransform: "uppercase"
    }
  },
  subtitle: {
    style: {
      color: "#E0E0E3",
      textTransform: "uppercase"
    }
  },
  xAxis: {
    gridLineColor: "#707073",
    labels: {
      style: {
        color: "#E0E0E3"
      }
    },
    lineColor: "#707073",
    minorGridLineColor: "#505053",
    tickColor: "#707073",
    title: {
      style: {
        color: "#A0A0A3"
      }
    }
  },
  yAxis: {
    gridLineColor: "#707073",
    labels: {
      style: {
        color: "#E0E0E3"
      }
    },
    lineColor: "#707073",
    minorGridLineColor: "#505053",
    tickColor: "#707073",
    tickWidth: 1,
    title: {
      style: {
        color: "#A0A0A3"
      }
    }
  },
  tooltip: {
    backgroundColor: "rgba(0, 0, 0, 0.85)",
    style: {
      color: "#F0F0F0"
    }
  },
  plotOptions: {
    series: {
      dataLabels: {
        color: "#B0B0B3"
      },
      marker: {
        lineColor: "#333"
      }
    },
    boxplot: {
      fillColor: "#505053"
    },
    candlestick: {
      lineColor: "white"
    },
    errorbar: {
      color: "white"
    }
  },
  legend: {
    itemStyle: {
      color: "#E0E0E3"
    },
    itemHoverStyle: {
      color: "#FFF"
    },
    itemHiddenStyle: {
      color: "#606063"
    }
  },
  credits: {
    style: {
      color: "#666"
    }
  },
  labels: {
    style: {
      color: "#707073"
    }
  },

  drilldown: {
    activeAxisLabelStyle: {
      color: "#F0F0F3"
    },
    activeDataLabelStyle: {
      color: "#F0F0F3"
    }
  },

  navigation: {
    buttonOptions: {
      symbolStroke: "#DDDDDD",
      theme: {
        fill: "#505053"
      }
    }
  },

  // scroll charts
  rangeSelector: {
    buttonTheme: {
      fill: "#505053",
      stroke: "#000000",
      style: {
        color: "#CCC"
      },
      states: {
        hover: {
          fill: "#707073",
          stroke: "#000000",
          style: {
            color: "white"
          }
        },
        select: {
          fill: "#000003",
          stroke: "#000000",
          style: {
            color: "white"
          }
        }
      }
    },
    inputBoxBorderColor: "#505053",
    inputStyle: {
      backgroundColor: "#333",
      color: "silver"
    },
    labelStyle: {
      color: "silver"
    }
  },

  navigator: {
    handles: {
      backgroundColor: "#666",
      borderColor: "#AAA"
    },
    outlineColor: "#CCC",
    maskFill: "rgba(255,255,255,0.1)",
    series: {
      color: "#7798BF",
      lineColor: "#A6C7ED"
    },
    xAxis: {
      gridLineColor: "#505053"
    }
  },

  scrollbar: {
    barBackgroundColor: "#808083",
    barBorderColor: "#808083",
    buttonArrowColor: "#CCC",
    buttonBackgroundColor: "#606063",
    buttonBorderColor: "#606063",
    rifleColor: "#FFF",
    trackBackgroundColor: "#404043",
    trackBorderColor: "#404043"
  },

  // special colors for some of the
  legendBackgroundColor: "rgba(0, 0, 0, 0.5)",
  background2: "#505053",
  dataLabelsColor: "#B0B0B3",
  textColor: "#C0C0C0",
  contrastTextColor: "#F0F0F3",
  maskColor: "rgba(255,255,255,0.3)"
};

var map_theme = {
  styleJson: [
    {
      featureType: "land",
      elementType: "all",
      stylers: {
        color: "#091934"
      }
    },
    {
      featureType: "water",
      elementType: "all",
      stylers: {
        color: "#044161"
      }
    },
    {
      featureType: "green",
      elementType: "all",
      stylers: {
        color: "#056197",
        visibility: "off"
      }
    },
    {
      featureType: "manmade",
      elementType: "all",
      stylers: {
        visibility: "off"
      }
    },
    {
      featureType: "building",
      elementType: "all",
      stylers: {
        color: "#403f3dff",
        visibility: "off"
      }
    },
    {
      featureType: "subway",
      elementType: "all",
      stylers: {
        visibility: "off"
      }
    },
    {
      featureType: "highway",
      elementType: "geometry",
      stylers: {
        color: "#004981"
      }
    },
    {
      featureType: "highway",
      elementType: "geometry.fill",
      stylers: {
        color: "#005b96",
        lightness: 1
      }
    },
    {
      featureType: "arterial",
      elementType: "geometry",
      stylers: {
        color: "#004981",
        lightness: -39
      }
    },
    {
      featureType: "local",
      elementType: "all",
      stylers: {
        visibility: "off"
      }
    },
    {
      featureType: "railway",
      elementType: "all",
      stylers: {
        visibility: "off"
      }
    },
    {
      featureType: "arterial",
      elementType: "geometry.fill",
      stylers: {
        color: "#00508b"
      }
    },
    {
      featureType: "local",
      elementType: "labels.text.fill",
      stylers: {
        color: "#ccccccff"
      }
    },
    {
      featureType: "railway",
      elementType: "geometry.fill",
      stylers: {
        color: "#403f3dff"
      }
    },
    {
      featureType: "building",
      elementType: "all",
      stylers: {}
    },
    {
      featureType: "town",
      elementType: "labels.text.fill",
      stylers: {
        color: "#ccccccff"
      }
    },
    {
      featureType: "town",
      elementType: "labels.text.stroke",
      stylers: {
        color: "#000000ff"
      }
    },
    {
      featureType: "district",
      elementType: "labels.text.fill",
      stylers: {
        color: "#999999ff"
      }
    },
    {
      featureType: "district",
      elementType: "labels.text.stroke",
      stylers: {
        color: "#000000ff"
      }
    },
    {
      featureType: "district",
      elementType: "labels.text.fill",
      stylers: {
        color: "#ccccccff"
      }
    },
    {
      featureType: "city",
      elementType: "labels.text.fill",
      stylers: {
        color: "#ccccccff"
      }
    },
    {
      featureType: "airportlabel",
      elementType: "labels.text.fill",
      stylers: {
        color: "#ccccccff"
      }
    },
    {
      featureType: "scenicspotslabel",
      elementType: "labels.text.fill",
      stylers: {
        color: "#ccccccff"
      }
    },
    {
      featureType: "scenicspotslabel",
      elementType: "labels.text.stroke",
      stylers: {
        color: "#000000ff"
      }
    },
    {
      featureType: "educationlabel",
      elementType: "labels.text.fill",
      stylers: {
        color: "#ccccccff"
      }
    },
    {
      featureType: "educationlabel",
      elementType: "labels.text.stroke",
      stylers: {
        color: "#000000ff"
      }
    },
    {
      featureType: "medicallabel",
      elementType: "labels.text.fill",
      stylers: {
        color: "#ccccccff"
      }
    },
    {
      featureType: "medicallabel",
      elementType: "labels.text.stroke",
      stylers: {
        color: "#000000ff"
      }
    },
    {
      featureType: "city",
      elementType: "labels.text.fill",
      stylers: {
        color: "#ccccccff"
      }
    },
    {
      featureType: "city",
      elementType: "labels.text.stroke",
      stylers: {
        color: "#000000ff"
      }
    },
    {
      featureType: "town",
      elementType: "all",
      stylers: {}
    },
    {
      featureType: "airportlabel",
      elementType: "labels.text.fill",
      stylers: {
        color: "#999999ff"
      }
    },
    {
      featureType: "airportlabel",
      elementType: "labels.text.stroke",
      stylers: {
        color: "#000000ff"
      }
    },
    {
      featureType: "city",
      elementType: "labels.text.stroke",
      stylers: {
        color: "#000000ff"
      }
    },
    {
      featureType: "poi",
      elementType: "all",
      stylers: {
        visibility: "off"
      }
    },
    {
      featureType: "all",
      elementType: "labels.icon",
      stylers: {
        visibility: "off"
      }
    },
    {
      featureType: "town",
      elementType: "labels.text.stroke",
      stylers: {
        color: "#000000ff",
        visibility: "off"
      }
    },
    {
      featureType: "districtlabel",
      elementType: "all",
      stylers: {
        color: "#999999ff"
      }
    },
    {
      featureType: "districtlabel",
      elementType: "labels.text.stroke",
      stylers: {
        color: "#000000ff",
        visibility: "off"
      }
    },
    {
      featureType: "poilabel",
      elementType: "all",
      stylers: {
        color: "#ccccccff"
      }
    },
    {
      featureType: "poilabel",
      elementType: "labels.text.stroke",
      stylers: {
        color: "#000000ff"
      }
    },
    {
      featureType: "poilabel",
      elementType: "all",
      stylers: {
        color: "#999999ff"
      }
    },
    {
      featureType: "poilabel",
      elementType: "labels.text.stroke",
      stylers: {
        color: "#000000ff"
      }
    },
    {
      featureType: "poilabel",
      elementType: "labels.icon",
      stylers: {
        visibility: "off"
      }
    },
    {
      featureType: "manmade",
      elementType: "labels.text.fill",
      stylers: {
        color: "#999999ff"
      }
    },
    {
      featureType: "manmade",
      elementType: "labels.text.stroke",
      stylers: {
        color: "#000000ff"
      }
    },
    {
      featureType: "road",
      elementType: "labels.text.fill",
      stylers: {
        color: "#999999ff",
        visibility: "on"
      }
    },
    {
      featureType: "road",
      elementType: "labels.text.stroke",
      stylers: {
        color: "#000000ff",
        visibility: "on"
      }
    }
  ]
};

var map_theme = {
  styleJson: [
    {
      featureType: "water",
      elementType: "all",
      stylers: {
        color: "#044161"
      }
    },
    {
      featureType: "land",
      elementType: "all",
      stylers: {
        color: "#091934"
      }
    },
    {
      featureType: "boundary",
      elementType: "geometry",
      stylers: {
        color: "#064f85"
      }
    },
    {
      featureType: "railway",
      elementType: "all",
      stylers: {
        visibility: "off"
      }
    },
    {
      featureType: "highway",
      elementType: "geometry",
      stylers: {
        color: "#004981",
        visibility: "on"
      }
    },
    {
      featureType: "highway",
      elementType: "geometry.fill",
      stylers: {
        color: "#005b96",
        lightness: 1,
        visibility: "on"
      }
    },
    {
      featureType: "arterial",
      elementType: "geometry",
      stylers: {
        color: "#004981",
        lightness: -39,
        visibility: "on"
      }
    },
    {
      featureType: "arterial",
      elementType: "geometry.fill",
      stylers: {
        color: "#00508b",
        visibility: "on"
      }
    },
    {
      featureType: "poi",
      elementType: "all",
      stylers: {
        visibility: "on"
      }
    },
    {
      featureType: "green",
      elementType: "all",
      stylers: {
        color: "#056197",
        visibility: "off"
      }
    },
    {
      featureType: "subway",
      elementType: "all",
      stylers: {
        visibility: "off"
      }
    },
    {
      featureType: "manmade",
      elementType: "all",
      stylers: {
        visibility: "off"
      }
    },
    {
      featureType: "local",
      elementType: "all",
      stylers: {
        visibility: "off"
      }
    },
    {
      featureType: "arterial",
      elementType: "labels",
      stylers: {
        visibility: "on"
      }
    },
    {
      featureType: "boundary",
      elementType: "geometry.fill",
      stylers: {
        color: "#029fd4"
      }
    },
    {
      featureType: "building",
      elementType: "all",
      stylers: {
        color: "#1a5787",
        visibility: "off"
      }
    },
    {
      featureType: "label",
      elementType: "all",
      stylers: {
        visibility: "off"
      }
    },
    {
      featureType: "administrative",
      elementType: "labels.text.stroke",
      stylers: {
        color: "#000000ff",
        hue: "#000000",
        visibility: "on"
      }
    },
    {
      featureType: "road",
      elementType: "labels.text.fill",
      stylers: {
        color: "#999999ff",
        hue: "#999999",
        visibility: "on"
      }
    },
    {
      featureType: "road",
      elementType: "labels.text.stroke",
      stylers: {
        color: "#000000ff",
        hue: "#000000",
        visibility: "on"
      }
    },
    {
      featureType: "administrative",
      elementType: "labels.text.fill",
      stylers: {
        color: "#999999ff",
        hue: "#666666",
        visibility: "on"
      }
    },
    {
      featureType: "district",
      elementType: "labels",
      stylers: {
        visibility: "on"
      }
    },
    {
      featureType: "town",
      elementType: "labels",
      stylers: {
        visibility: "off"
      }
    },
    {
      featureType: "poilabel",
      elementType: "labels.text.fill",
      stylers: {
        color: "#999999ff",
        hue: "#666666",
        visibility: "on"
      }
    },
    {
      featureType: "poilabel",
      elementType: "labels.text.stroke",
      stylers: {
        color: "#000000ff",
        hue: "#000000"
      }
    },
    {
      featureType: "poilabel",
      elementType: "labels.icon",
      stylers: {
        visibility: "off"
      }
    }
  ]
};

var map_theme_dark = {
  styleJson: [
    {
      featureType: "land",
      elementType: "all",
      stylers: {
        color: "#343232ff"
      }
    },
    {
      featureType: "water",
      elementType: "all",
      stylers: {
        color: "#191a1aff"
      }
    },
    {
      featureType: "green",
      elementType: "all",
      stylers: {
        color: "#403f3dff"
      }
    },
    {
      featureType: "manmade",
      elementType: "all",
      stylers: {
        color: "#403f3dff"
      }
    },
    {
      featureType: "building",
      elementType: "all",
      stylers: {
        color: "#403f3dff"
      }
    },
    {
      featureType: "subway",
      elementType: "all",
      stylers: {
        visibility: "off"
      }
    },
    {
      featureType: "highway",
      elementType: "geometry",
      stylers: {
        color: "#403f3dff"
      }
    },
    {
      featureType: "highway",
      elementType: "labels",
      stylers: {
        color: "#00ff00ff"
      }
    },
    {
      featureType: "highway",
      elementType: "labels",
      stylers: {
        color: "#a6a0a0ff",
        weight: "0.1"
      }
    },
    {
      featureType: "arterial",
      elementType: "geometry",
      stylers: {
        color: "#403f3dff"
      }
    },
    {
      featureType: "local",
      elementType: "geometry",
      stylers: {
        color: "#403f3dff"
      }
    },
    {
      featureType: "railway",
      elementType: "geometry",
      stylers: {
        color: "#403f3dff"
      }
    },
    {
      featureType: "arterial",
      elementType: "labels",
      stylers: {
        color: "#999999ff"
      }
    },
    {
      featureType: "local",
      elementType: "labels",
      stylers: {
        color: "#999999ff"
      }
    },
    {
      featureType: "railway",
      elementType: "labels",
      stylers: {
        color: "#999999ff"
      }
    },
    {
      featureType: "highway",
      elementType: "labels.text.stroke",
      stylers: {
        color: "#000000ff",
        lightness: -16,
        saturation: -51
      }
    },
    {
      featureType: "arterial",
      elementType: "geometry",
      stylers: {
        color: "#000000ff"
      }
    },
    {
      featureType: "arterial",
      elementType: "labels.text.stroke",
      stylers: {
        color: "#000000ff"
      }
    },
    {
      featureType: "local",
      elementType: "geometry",
      stylers: {}
    },
    {
      featureType: "local",
      elementType: "geometry",
      stylers: {
        color: "#403f3dff"
      }
    },
    {
      featureType: "local",
      elementType: "geometry",
      stylers: {
        color: "#403f3dff"
      }
    },
    {
      featureType: "arterial",
      elementType: "geometry.fill",
      stylers: {
        color: "#444444ff"
      }
    },
    {
      featureType: "arterial",
      elementType: "all",
      stylers: {
        color: "#403f3dff"
      }
    },
    {
      featureType: "arterial",
      elementType: "labels.text.fill",
      stylers: {
        color: "#999999ff"
      }
    },
    {
      featureType: "arterial",
      elementType: "labels.text.fill",
      stylers: {
        color: "#ccccccff"
      }
    },
    {
      featureType: "arterial",
      elementType: "labels.text.stroke",
      stylers: {
        color: "#000000ff"
      }
    },
    {
      featureType: "railway",
      elementType: "geometry.fill",
      stylers: {
        color: "#403f3dff"
      }
    },
    {
      featureType: "railway",
      elementType: "labels.text.fill",
      stylers: {
        color: "#ccccccff"
      }
    },
    {
      featureType: "railway",
      elementType: "labels.text.stroke",
      stylers: {
        color: "#000000ff"
      }
    },
    {
      featureType: "building",
      elementType: "all",
      stylers: {}
    },
    {
      featureType: "town",
      elementType: "labels.text.fill",
      stylers: {
        color: "#ccccccff"
      }
    },
    {
      featureType: "town",
      elementType: "labels.text.stroke",
      stylers: {
        color: "#000000ff"
      }
    },
    {
      featureType: "district",
      elementType: "labels.text.fill",
      stylers: {
        color: "#999999ff"
      }
    },
    {
      featureType: "district",
      elementType: "labels.text.stroke",
      stylers: {
        color: "#000000ff"
      }
    },
    {
      featureType: "district",
      elementType: "labels.text.fill",
      stylers: {
        color: "#ccccccff"
      }
    },
    {
      featureType: "city",
      elementType: "labels.text.fill",
      stylers: {
        color: "#ccccccff"
      }
    },
    {
      featureType: "airportlabel",
      elementType: "labels.text.fill",
      stylers: {
        color: "#ccccccff"
      }
    },
    {
      featureType: "scenicspotslabel",
      elementType: "labels.text.fill",
      stylers: {
        color: "#ccccccff"
      }
    },
    {
      featureType: "scenicspotslabel",
      elementType: "labels.text.stroke",
      stylers: {
        color: "#000000ff"
      }
    },
    {
      featureType: "educationlabel",
      elementType: "labels.text.fill",
      stylers: {
        color: "#ccccccff"
      }
    },
    {
      featureType: "educationlabel",
      elementType: "labels.text.stroke",
      stylers: {
        color: "#000000ff"
      }
    },
    {
      featureType: "medicallabel",
      elementType: "labels.text.fill",
      stylers: {
        color: "#ccccccff"
      }
    },
    {
      featureType: "medicallabel",
      elementType: "labels.text.stroke",
      stylers: {
        color: "#000000ff"
      }
    },
    {
      featureType: "city",
      elementType: "labels.text.fill",
      stylers: {
        color: "#ccccccff"
      }
    },
    {
      featureType: "city",
      elementType: "labels.text.stroke",
      stylers: {
        color: "#000000ff"
      }
    },
    {
      featureType: "town",
      elementType: "all",
      stylers: {}
    },
    {
      featureType: "airportlabel",
      elementType: "labels.text.fill",
      stylers: {
        color: "#999999ff"
      }
    },
    {
      featureType: "airportlabel",
      elementType: "labels.text.stroke",
      stylers: {
        color: "#000000ff"
      }
    },
    {
      featureType: "city",
      elementType: "labels.text.stroke",
      stylers: {
        color: "#000000ff"
      }
    },
    {
      featureType: "poi",
      elementType: "all",
      stylers: {
        visibility: "off"
      }
    },
    {
      featureType: "all",
      elementType: "labels.icon",
      stylers: {
        visibility: "off"
      }
    },
    {
      featureType: "town",
      elementType: "labels.text.stroke",
      stylers: {
        color: "#000000ff",
        visibility: "off"
      }
    },
    {
      featureType: "districtlabel",
      elementType: "all",
      stylers: {
        color: "#999999ff"
      }
    },
    {
      featureType: "districtlabel",
      elementType: "labels.text.stroke",
      stylers: {
        color: "#000000ff",
        visibility: "off"
      }
    },
    {
      featureType: "poilabel",
      elementType: "all",
      stylers: {
        color: "#999999ff"
      }
    },
    {
      featureType: "poilabel",
      elementType: "labels.text.stroke",
      stylers: {
        color: "#000000ff",
        visibility: "on"
      }
    },
    {
      featureType: "poilabel",
      elementType: "labels.icon",
      stylers: {
        visibility: "off"
      }
    },
    {
      featureType: "manmade",
      elementType: "labels.text.fill",
      stylers: {
        color: "#999999ff"
      }
    },
    {
      featureType: "manmade",
      elementType: "labels.text.stroke",
      stylers: {
        color: "#000000ff"
      }
    },
    {
      featureType: "poilabel",
      elementType: "labels.text.fill",
      stylers: {
        color: "#999999ff",
        visibility: "on"
      }
    },
    {
      featureType: "local",
      elementType: "labels.text.stroke",
      stylers: {
        color: "#000000ff",
        visibility: "on"
      }
    }
  ]
};
export { theme, map_theme, map_theme_dark };
